var $760f46c8bf4d0bd2$exports = {};
$760f46c8bf4d0bd2$exports = {
    "clear": `L\xf6schen`,
    "invalid": `(ung\xfcltig)`,
    "loading": `Wird geladen...`,
    "noResults": `Keine Ergebnisse`,
    "valid": `(g\xfcltig)`
};


export {$760f46c8bf4d0bd2$exports as default};
//# sourceMappingURL=de-DE.module.js.map
